const useTheme = (): string => {

    const date = new Date();
    const month = date.getMonth();
    const day = date.getDate()

    return ((month === 10 && day >= 15) || month === 11) ? "christmas" : null;
}

export default useTheme;